'use strict';

const permissions = require('./permissions');
const adminClientPermissions = require('./adminClient');
const featureManagerPermissions = require('./featureManager');
const partnerPermissions = require('./partner');
const crmPermissions = require('./crm');
const baseRole = require('./baseRole');

module.exports = {
  default: {
    [permissions.ADMIN_GLOBAL]: false,
    [permissions.ADMIN_CLIENT]: false,
    ...baseRole,
  },
  admin: {
    [permissions.ADMIN_GLOBAL]: true,
  },
  adminClient: {
    [permissions.ADMIN_CLIENT]: true,
    ...adminClientPermissions,
  },
  featureManager: {
    ...featureManagerPermissions,
  },
  partner: {
    ...partnerPermissions,
  },
  crm: {
    ...crmPermissions,
  },
};
